import { Redirect } from "react-router-dom";
import { LoginBoxStyled, LoginStyled } from "./styled/LoginStyled";
import { useSelector } from "react-redux";
import { getLoggedIn } from "../authSelectors";
import RouterPaths from "../../../app/routePaths";
import Reset from "./Reset";

export default function ResetPage() {
    const isLoggedIn = useSelector(getLoggedIn);

    if (isLoggedIn) {
        return <Redirect to={RouterPaths.main}/>
    }

    return <>
        <LoginStyled>
            <LoginBoxStyled>
                <Reset/>
            </LoginBoxStyled>
        </LoginStyled>
    </>
}
